<script lang="ts" module>
  import type { Snippet } from 'svelte';

  import CardLoading from './CardLoading.svelte';

  export interface AdditionalProps {
    cardLabel: string;
    loading?: boolean;
    children?: Snippet;
  }

  export type CardHeaderProps = AdditionalProps;
</script>

<script lang="ts">
  let {
    loading: loadingProp = false,
    cardLabel: cardLabelProp = 'Card',
    ...props
  }: CardHeaderProps = $props();
</script>

<div class="flex items-center gap-2">
  <p class="flex-grow font-sans text-sm font-semibold text-c-base">
    {cardLabelProp}
  </p>
  {#if loadingProp}
    <span class="flex min-h-7 w-32 flex-initial"><CardLoading></CardLoading></span>
  {:else}
    {@render props.children?.()}
  {/if}
</div>
